// store/slices/settlements/productSettlementSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ProductSettlementStatus,
  ProductSettlementSummary,
} from '../../../types/settlement/SettlementTypes';

interface ProductSettlementState {
  settlementSummary: ProductSettlementSummary | null;
  generalSettlement: ProductSettlementStatus[];
  showSettlementModal: boolean;
  showGeneralSettlementModal: boolean;
  error: string | null;
}

const initialState: ProductSettlementState = {
  settlementSummary: null,
  generalSettlement: [],
  showSettlementModal: false,
  showGeneralSettlementModal: false,
  error: null,
};

const productSettlementSlice = createSlice({
  name: 'productSettlement',
  initialState,
  reducers: {
    /**
     * 🔄 Actualiza el resumen del producto asentado (producto + status + detalles)
     */
    setSettlementSummary(state, action: PayloadAction<ProductSettlementSummary>) {
      state.settlementSummary = action.payload;
    },

    /**
     * 🔄 Actualiza la lista de estados generales después de un asentamiento masivo
     */
    setGeneralSettlement(state, action: PayloadAction<ProductSettlementStatus[]>) {
      state.generalSettlement = action.payload;
    },

    /**
     * ⚠️ Registra un error relacionado al proceso de asentamiento
     */
    setSettlementError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },

    /**
     * 🧹 Limpia todo el estado relacionado al asentamiento de productos
     */
    clearSettlementState(state) {
      state.settlementSummary = null;
      state.generalSettlement = [];
      state.error = null;
      state.showSettlementModal = false;
      state.showGeneralSettlementModal = false;
    },

    /**
     * 🪟 Controla la visualización del modal de asentamiento individual
     */
    setShowSettlementModal(state, action: PayloadAction<boolean>) {
      state.showSettlementModal = action.payload;
    },

    /**
     * 🪟 Controla la visualización del modal de asentamiento general
     */
    setShowGeneralSettlementModal(state, action: PayloadAction<boolean>) {
      state.showGeneralSettlementModal = action.payload;
    },
  },
});

export const {
  setSettlementSummary,
  setGeneralSettlement,
  setSettlementError,
  clearSettlementState,
  setShowSettlementModal,
  setShowGeneralSettlementModal,
} = productSettlementSlice.actions;

export default productSettlementSlice.reducer;
